import "../../libs/backbone/backbone.ajaxq.adapter.ts";
import GenericView from 'views/generic.view.ts';
import Handlebars from 'handlebars';
import Template from 'text-loader!../templates/account.template.htm';
import 'dhtmlxMessage';
import Model from '../models/account.model.ts';
import i18n  from "l10n";

export default GenericView.extend({
    el: "#container",
    tagName: 'div',
	template: Handlebars.compile(Template),
	Model : null,
	userData: null,
    numberPrivilegeLevel: null,
	initialize: function (options) {
		self = this;
		this.userData = options.data;
		this.numberPrivilegeLevel = this.privilegeLevelToNumber(this.userData.privilegeLevel);
		this.model = new Model({privilegeLevel: this.numberPrivilegeLevel});
		this.model.fetch({
			success: function(response)
			{
        		self.render();
			},
			error: function(response, xhr, status)
			{
				var self = this;
				if (xhr.status == 401) {
                    window.open('./','_self');
				} else if(xhr.status == 403){
					window.open('./','_self');
				}
			}
		});

		this.fields =
        {
            name: [this.isEmpty],
            lastName: [this.isEmpty],
            phone: [this.isEmpty],
            //birthday: [this.isEmpty, this.isNotDate]
        };
	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;
		this.$el.html(this.template( {model: this.model.toJSON(), privilegeLevel: this.numberPrivilegeLevel}));
	},
	events:{
		"click #submit": "clickOnSubmit",
		"click #cancel": "goBack",
        "change .to-validation input": "validateIt",
        "keyup .to-validation input": "validateIt",
        "keyup .password-validation input": "checkPasswords",
        "focusout #email input": "validateExistEmail",
	},
	validateExistEmail: function(event) {
        var self = this;
        this.has_error4 = false;
        this.has_error4 = this.validateFields({email: [this.isEmpty, this.isEmail]});

        if(this.has_error4 || !event)
            return this.has_error4;

        var element = $(event.currentTarget);
        var email = element.val();
        if(this.model)
        {
            if(this.model.get("email") == email)
            {
                this.clearError(element.parent());
                return;
            }
        }

        $.ajaxDefaultQ({
            url: "rest/api/users/email/exists",
            type: "GET",
            data: "email="+email,
        }).done(function(response, status, xhr){
            if(response.data.value) {
                self.setError($("#email"), i18n.t("user.email_exists"));
                self.has_error4 = true;
                return self.has_error4;
            } else {
                self.clearError($("#email"));
            }
        })
        .fail(function(response) {
            console.error();
            $.notify(
                i18n.t("user.error"),
                { position:"top center", className: "error" }
            );
            self.has_error4 = true;
            return self.has_error4;
        });
    },
	validateIt: function(event)
    {
        var element = $(event.currentTarget).parent();
        var field = {};
        field[element.prop("id")] = this.fields[element.prop("id")]
        this.validateFields( field );
    },
    checkPasswords: function() {
        var has_error = false;
        this.oldPassword = $("#password").find("input").val().trim();
        this.newPassword = $("#new_password").find("input").val().trim();
        this.confirmPassword = $("#confirm_new_password").find("input").val().trim();

        if(this.oldPassword != "" || this.newPassword != "" || this.confirmPassword != "") {
            if(this.oldPassword == "") {
                this.setError($("#password"), i18n.t("account.type_old_pswd"));
                has_error = true;
            } else {
                 this.clearError($("#password"));
            }

            if(this.newPassword == "") {
                this.setError($("#new_password"), i18n.t("account.type_new_pswd"));
                has_error = true;
            } else {
                if (!this.newPassword.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{6,})/) ){
                    this.setError($("#new_password"), i18n.t("account.pswd_prompt"));
                    has_error = true;
                } else
                    this.clearError($("#new_password"));
            }

            if(this.confirmPassword == "") {
                if(this.newPassword != "") {
                    this.setError($("#confirm_new_password"), i18n.t("account.confirm_pswd"));
                    has_error = true;
                } else {
                    this.clearError($("#confirm_new_password"));
                }
            } else {
                if(this.confirmPassword != this.newPassword ) {
                    this.setError($("#confirm_new_password"), i18n.t("account.pswds_not_match"));
                    has_error = true;
                } else {
                    this.clearError($("#confirm_new_password"));
                }
            }
        } else {
            this.clearError($("#confirm_new_password"));
            this.clearError($("#password"));
            this.clearError($("#new_password"));
        }

        return has_error;
    },
	clickOnSubmit: function()
	{
		var self = this;
        var fields = $.extend({}, this.fields);

        var has_error = this.validateFields(fields);
        var has_error2 = this.checkPasswords();
        this.has_error4 = this.validateExistEmail();

        if(!has_error && !has_error2 && !this.has_error4 )
        {
            this.model.set("name", $("#name").find("input").val());
            this.model.set("lastName", $("#lastName").find("input").val());
            this.model.set("email", $("#email").find("input").val());
            this.model.set("phone", $("#phone").find("input").val());
            //this.model.set("birthday", $("#birthday").find("input").val());
            if(this.oldPassword != "" && this.newPassword != "" && this.confirmPassword != "") {
                this.model.set("oldPassword", $("#password").find("input").val());
                this.model.set("password", $("#new_password").find("input").val());
            }
            else
            {

            }
            this.showActionProgressBar();
            this.model.url = 'rest/api/users/' + this.model.get("id");

            $.when(window.ping()).then(function(resp) {
                $.ajaxSetup({
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('X-CSRF-TOKEN', window.csrf);
                    }
                });

                self.model.save(null, {
                    success: function(response)
                    {
                        self.hideActionProgressBar();

                        //clear change password fields
                        if(self.oldPassword != "" && self.newPassword != "" && self.confirmPassword != "") {
                            $("#password").find("input").val("");
                            $("#new_password").find("input").val("");
                            $("#confirm_new_password").find("input").val("");
                            self.oldPassword = null;
                            self.newPassword = null;
                            self.model.set("oldPassword", null);
                            self.model.set("password", null);
                        }

                        $.notify("Account updated successfully", { position:"top center", className: "success" });
                    },
                    error: function(response, xhr)
                    {
                        if (xhr.status == 401) {
                            window.open('./','_self');
                        } else if(xhr.status == 403){
                            window.open('./','_self');
                        }

                        if(status && status.responseJSON && status.responseJSON.error && status.responseJSON.error.causes) {
                            var errormsg = "";
                            for (var i=0; i<status.responseJSON.error.causes.length; i++) {
                                errormsg += status.responseJSON.error.causes[i].message + "\n";
                            }
                            $.notify(
                                i18n.t("account.check_errors") + "\n" + errormsg,
                                { position:"top center", className: "error" }
                            );
                        }

                        self.hideActionProgressBar();
                    }
                });
            });


        }
        else
        {
            $.notify(
                "Please check the errors",
                { position:"top center", className: "error" }
            );
        }
	},
});

